import {
  FETCH_ALL_VIDEOS,
  FETCH_VIDEO,
  UPLOAD_VIDEO,
  UPDATE_VIDEO,
  DELETE_VIDEO,
} from "./types";

const initialState = {
  loading: false,
  message: null,
  data: [],
  pagination:{}
};

export const galleryVideosReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_VIDEOS}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_ALL_VIDEOS}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results.data
        : [];
        const pagination = action.payload.data.results ? action.payload.data.results.pagination : {};
      return {
        ...state,
        loading: false,
        data: result,
        pagination: pagination,
        message: action.payload.data.message,
      };

    case `${FETCH_ALL_VIDEOS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const VideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_VIDEO}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_VIDEO}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_VIDEO}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const uploadVideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPLOAD_VIDEO}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPLOAD_VIDEO}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${UPLOAD_VIDEO}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateVideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_VIDEO}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_VIDEO}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_VIDEO}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteVideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_VIDEO}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_VIDEO}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload.message : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_VIDEO}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
